import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    zIndex: '99',
    position: 'sticky',
    marginBottom: '24px',
    marginRight: '24px',
    top: '74%',
    left: '90%',
    fontSize: idsTokens.typography.font.size.base,
    fontWeight: idsTokens.typography.font.weight.medium,
    letterSpacing: idsTokens.typography.spacing.letter.lg,
    lineHeight: idsTokens.typography.lineHeight.base,
    padding: `${idsTokens.button.default.spacing.standard.primary.padding.top} ${idsTokens.button.default.spacing.standard.primary.padding.right} ${idsTokens.button.default.spacing.standard.primary.padding.bottom} ${idsTokens.button.default.spacing.standard.primary.padding.left}`,
    borderRadius: `${idsTokens.fab.default.radius.topLeft} ${idsTokens.fab.default.radius.topRight} ${idsTokens.fab.default.radius.bottomRight} ${idsTokens.fab.default.radius.bottomLeft}`,
    border: `1px solid ${idsTokens.button.default.color.primary.border.enabled}`,
    background: idsTokens.button.default.color.primary.background.enabled,
    boxShadow: `${idsTokens.fab.default.shadow.x} ${idsTokens.fab.default.shadow.y} ${idsTokens.fab.default.shadow.blur} ${idsTokens.fab.default.shadow.spread} ${idsTokens.fab.default.shadow.color}`,
    color: idsTokens.button.default.color.primary.content.enabled,
    bottom: '0',
    right: '0',
    width: idsTokens.fab.default.sizing.noLabel.width,
    height: idsTokens.fab.default.sizing.noLabel.height,
    '&.MuiFab-extended': {
      width: 'unset',
      backgroundSize: 'calc(100% + 6px) auto',
      backgroundPosition: '-3px 0',
    },
    '& .MuiSvgIcon-root': {
      width: 20,
      height: 20,
    },
    '&[disabled]': {
      color: idsTokens.button.default.color.primary.content.disabled,
      backgroundColor: idsTokens.button.default.color.primary.background.disabled,
      border: `1px solid ${idsTokens.button.default.color.primary.border.disabled}`,
      boxShadow: `${idsTokens.fab.default.shadow.x} ${idsTokens.fab.default.shadow.y} ${idsTokens.fab.default.shadow.blur} ${idsTokens.fab.default.shadow.spread} ${idsTokens.fab.default.shadow.color} !important`,
    },
    '&:hover': {
      backgroundColor: idsTokens.button.default.color.primary.background.hover,
    },
    '&:active': {
      backgroundColor: idsTokens.button.default.color.primary.background.pressed,
      boxShadow: `${idsTokens.fab.default.shadow.x} ${idsTokens.fab.default.shadow.y} ${idsTokens.fab.default.shadow.blur} ${idsTokens.fab.default.shadow.spread} ${idsTokens.fab.default.shadow.color}`,
    },
    '&:focus-visible, &.Mui-focused': {
      outlineOffset: '2px',
      outline: `${idsTokens.functional.borderWidth.focus.default} solid ${idsTokens.functional.color.border.focus}`,
      boxShadow: 'none',
      '&::after': {
        content: '""',
        position: 'absolute',
        inset: '-5px',
        borderRadius: 'inherit',
        boxShadow: `${idsTokens.fab.default.shadow.x} ${idsTokens.fab.default.shadow.y} ${idsTokens.fab.default.shadow.blur} ${idsTokens.fab.default.shadow.spread} ${idsTokens.fab.default.shadow.color}`,
        zIndex: -1,
        pointerEvents: 'none',
      },
    },
  },
});
